/**
 * street-drama-timeline.js
 * Các hàm phân cảnh timeline cho hoạt cảnh "Tranh Khách Vỉa Hè" 62 giây.
 * Điều phối chính xác từng frame hành động, vị trí, biểu cảm, phụ đề,
 * camera cinematic và âm thanh va chạm cho 4 nhân vật.
 */

// ========================================================
// PHÂN CẢNH 1: XANH SM ĐÓN KHÁCH & GRAB TRANH KHÁCH (0.0s -> 12.0s)
// ========================================================
export function applyScene1(director, time, actors) {
  const { ba, grab, xanh, trada } = actors;
  const sceneIndex = 0;
  let subtitleText = '';
  let speakerName = '';

  // Bác Ba đứng trên vỉa hè
  ba.root.position.set(0, 0.22, -3.8);
  ba.root.rotation.y = 0;

  // Bác Tài Xanh SM đã đến trước, niềm nở đón Bác Ba
  xanh.root.position.set(0.85, 0.22, -3.8);
  xanh.root.rotation.y = -Math.PI * 0.4;
  xanh.playAction('greet');
  xanh.setExpression('happy');

  // Bác Trà Đá đứng thong thả trong quán
  trada.root.position.set(2.8, 0.22, -4.3);
  trada.root.rotation.y = -Math.PI * 0.25;
  trada.playAction('idle');
  trada.setExpression('neutral');

  // Giai đoạn 1.1: Xanh SM chào mời nồng nhiệt (0.0s - 6.0s)
  if (time < 6.0) {
    grab.root.position.set(-8.5, 0.22, -3.8);
    grab.playAction('idle');

    ba.playAction('wave');
    ba.setExpression('happy');

    grab.hideSpeech();
    speakerName = 'Bác Tài Xanh SM';
    subtitleText = 'Bác Ba ơi! Đi Xanh SM đi bác! Xe điện VinFast êm ru mát rượi nè!';
    xanh.speak('Đi Xanh SM xe điện VinFast êm ru bác ơi!', 4500);
    director.speakTts(subtitleText, 's1_xanh', 'TAI_XE_XANH_SM');

    // Camera Medium Shot ấm cúng
    director.targetCamPos.set(0.2, 2.3, 4.2);
    director.targetLookAt.set(0.4, 1.0, -3.8);
  }
  // Giai đoạn 1.2: Grab chạy gấp rút tới chen ngang (6.0s - 12.0s)
  else {
    const pGrab = Math.min(1.0, (time - 6.0) / 3.0);
    const grabX = -8.0 + pGrab * (-0.85 - -8.0);
    grab.root.position.set(grabX, 0.22, -3.8);
    grab.root.rotation.y = Math.PI * 0.4;

    if (pGrab < 0.95) {
      grab.playAction('run');
    } else {
      grab.playAction('wave');
    }
    grab.setExpression('happy');

    ba.playAction('think');
    ba.setExpression('think');

    xanh.hideSpeech();
    speakerName = 'Tài xế Grab';
    subtitleText = 'Khoan đã Bác Ba! Đi Grab xe ôm bao rẻ, chạy nhanh lẹ nè bác ơi!';
    grab.speak('Khoan đã Bác Ba! Đi Grab bao rẻ lẹ nè!', 4500);
    director.speakTts(subtitleText, 's1_grab', 'TAI_XE_GRAB');

    // Camera Establishing Wide Shot bao quát cả phố
    director.targetCamPos.set(0.0, 2.8, 5.0);
    director.targetLookAt.set(0.0, 0.95, -3.8);
  }

  return { sceneIndex, subtitleText, speakerName };
}

// ========================================================
// PHÂN CẢNH 2: CÃI NHAU NẢY LỬA GÓC CAO THOÁNG ĐÃNG (12.0s -> 24.0s)
// ========================================================
export function applyScene2(director, time, actors) {
  const { ba, grab, xanh, trada } = actors;
  const sceneIndex = 1;
  const tInScene = time - 12.0;
  let subtitleText = '';
  let speakerName = '';

  // Hai tài xế quay sang đối mặt áp sát nhau (giữ khoảng cách an toàn 1.5m không lẫn body)
  grab.root.position.set(-0.75, 0.22, -3.8);
  grab.root.rotation.y = Math.PI * 0.5; // Nhìn sang Xanh SM
  grab.playAction('argue');
  grab.setExpression('angry');

  xanh.root.position.set(0.75, 0.22, -3.8);
  xanh.root.rotation.y = -Math.PI * 0.5; // Nhìn sang Grab
  xanh.playAction('argue');
  xanh.setExpression('angry');

  ba.root.position.set(0, 0.22, -4.7);
  ba.root.rotation.y = 0;
  ba.playAction('apologize');
  ba.setExpression('scared');

  trada.root.position.set(2.8, 0.22, -4.3);
  trada.root.rotation.y = -Math.PI * 0.4;
  trada.playAction('think');
  trada.setExpression('surprise');

  // Còi xe đường phố
  if (tInScene > 0.5 && !director.lastTriggeredSfx['honk_1']) {
    director.playCityHonk();
    director.lastTriggeredSfx['honk_1'] = true;
  }

  // 2.1: Xanh SM đối chất (12.0s - 16.0s, tức tInScene < 4.0)
  if (tInScene < 4.0) {
    speakerName = 'Bác Tài Xanh SM';
    subtitleText = 'Ủa em trai, tôi tới trước rước khách mà, sao chen ngang vậy?!';
    xanh.speak('Tôi tới trước đàng hoàng, sao chen ngang?!', 3800);
    grab.hideSpeech();
    ba.hideSpeech();
    director.speakTts(subtitleText, 's2_xanh', 'TAI_XE_XANH_SM');

    // GÓC MÁY CAO VÀ LÙI XA HƠN THEO GÓP Ý (y = 2.6m, z = 2.2m)
    director.targetCamPos.set(-1.8, 2.6, 2.2);
    director.targetLookAt.set(0.0, 1.15, -3.8);
  }
  // 2.2: Grab sừng sộ cãi tay đôi (16.0s - 20.0s, tức tInScene < 8.0)
  else if (tInScene < 8.0) {
    xanh.hideSpeech();
    ba.hideSpeech();
    speakerName = 'Tài xế Grab';
    subtitleText = 'Khách chưa lên xe thì ai nhanh người ấy bắt! Mày ý kiến gì?!';
    grab.speak('Khách chưa lên xe thì ai nhanh người ấy bắt!', 3800);
    director.speakTts(subtitleText, 's2_grab', 'TAI_XE_GRAB');

    // GÓC MÁY CAO VÀ LÙI XA HƠN CHUYỂN SANG PHÍA ĐỐI DIỆN
    director.targetCamPos.set(1.5, 2.6, 2.2);
    director.targetLookAt.set(0.0, 1.15, -3.8);
  }
  // 2.3: Bác Ba hốt hoảng can ngăn (20.0s - 24.0s, tức tInScene >= 8.0)
  else {
    grab.hideSpeech();
    xanh.hideSpeech();
    speakerName = 'Bác Ba Nam Bộ';
    subtitleText = 'Thôi thôi hai chú ơi! Đầu đường xó chợ đừng cãi lộn mất hòa khí!';
    ba.speak('Thôi thôi hai chú ơi đừng cãi lộn!', 3800);
    director.speakTts(subtitleText, 's2_ba', 'BAC_BA_BA');

    // GÓC MÁY CAO TRỰC DIỆN TOÀN CẢNH 3 NHÂN VẬT
    director.targetCamPos.set(0.0, 2.6, 2.4);
    director.targetLookAt.set(0.0, 1.15, -4.0);
  }

  return { sceneIndex, subtitleText, speakerName };
}

// ========================================================
// PHÂN CẢNH 3: BÁC TRÀ ĐÁ RA CAN & SNAP ZOOM ĐE DỌA (24.0s -> 32.0s)
// ========================================================
export function applyScene3(director, time, actors) {
  const { ba, grab, xanh, trada } = actors;
  const sceneIndex = 2;
  const tInScene = time - 24.0;
  const pWalk = Math.min(1.0, tInScene / 2.5);
  let subtitleText = '';
  let speakerName = '';

  // Bác Trà Đá bước từ quán ra giữa vỉa hè
  const tradaX = 2.8 - pWalk * (2.8 - 0.4);
  const tradaZ = -4.3 + pWalk * (-3.7 - -4.3);
  trada.root.position.set(tradaX, 0.22, tradaZ);
  trada.root.rotation.y = pWalk < 0.95 ? -Math.PI * 0.5 : -Math.PI * 0.35;
  if (pWalk < 0.95) {
    trada.playAction('walk');
    trada.setExpression('neutral');
  } else {
    trada.playAction('explain');
    trada.setExpression('explain');
  }

  xanh.root.position.set(1.35, 0.22, -3.8);
  xanh.root.rotation.y = -Math.PI * 0.4;
  xanh.playAction('idle');
  xanh.setExpression('neutral');

  grab.root.position.set(-0.75, 0.22, -3.7);
  grab.root.rotation.y = Math.PI * 0.35;

  ba.root.position.set(-0.2, 0.22, -4.7);
  ba.playAction('think');
  ba.setExpression('scared');

  // 3.1: Bác Trà Đá khuyên can (24.0s - 28.5s, tức tInScene < 4.5)
  if (tInScene < 4.5) {
    grab.playAction('argue');
    grab.setExpression('angry');

    ba.hideSpeech();
    xanh.hideSpeech();
    grab.hideSpeech();
    speakerName = 'Bác Bán Trà Đá';
    subtitleText = 'Hai cậu kia dừng tay lại! Có gì vào làm cốc trà đá cho hạ hỏa nào!';
    trada.speak('Hai cậu dừng tay lại, làm cốc trà đá hạ hỏa!', 4000);
    director.speakTts(subtitleText, 's3_trada', 'NGUOI_BAN_TRA_DA');

    // Camera Tracking lướt theo bước chân Bác Trà Đá
    director.targetCamPos.set(1.8, 1.8, 1.0);
    director.targetLookAt.set(0.0, 1.0, -3.7);
  }
  // 3.2: Grab giương nắm đấm đe dọa (28.5s - 32.0s, tức tInScene >= 4.5)
  else {
    grab.playAction('punch'); // Giương nắm đấm
    grab.setExpression('yelling');

    trada.hideSpeech();
    speakerName = 'Tài xế Grab';
    subtitleText = 'Lão già nhiều chuyện! Biến ngay không tao đấm vỡ mặt bây giờ?!';
    grab.speak('Lão già nhiều chuyện! Biến ngay kẻo ăn đấm!', 3200);
    director.speakTts(subtitleText, 's3_grab', 'TAI_XE_GRAB');

    // CINEMATIC SNAP ZOOM: Phóng nhanh góc nhìn cận chiến đe dọa
    director.targetCamPos.set(-0.85, 1.5, -1.8);
    director.targetLookAt.set(-0.65, 1.25, -3.7);
  }

  return { sceneIndex, subtitleText, speakerName };
}

// ========================================================
// PHÂN CẢNH 4: GAY CẤN - BULLET TIME NÉ ĐÒN & PHẢN ĐÒN & CẬN MẶT CHOÁNG VÁNG (32.0s -> 44.0s)
// ========================================================
export function applyScene4(director, time, actors) {
  const { ba, grab, xanh, trada } = actors;
  const sceneIndex = 3;
  const tInScene = time - 32.0;
  let subtitleText = '';
  let speakerName = '';

  ba.root.position.set(-0.3, 0.22, -4.7);
  ba.playAction('apologize');
  ba.setExpression('scared');

  xanh.root.position.set(1.4, 0.22, -3.8);
  xanh.playAction('idle');
  xanh.setExpression('surprise');

  // 4.1: Grab lao vào định đấm (32.0s - 34.5s, tức tInScene < 2.5)
  if (tInScene < 2.5) {
    const pPunch = tInScene / 2.5;
    grab.root.position.set(-0.75 + pPunch * 0.1, 0.22, -3.7);
    grab.root.rotation.y = Math.PI * 0.35;
    grab.playAction('punch');
    grab.setExpression('yelling');

    trada.root.position.set(0.4, 0.22, -3.7);
    trada.root.rotation.y = -Math.PI * 0.35;
    trada.playAction('idle');
    trada.setExpression('surprise');

    speakerName = 'Tài xế Grab';
    subtitleText = 'Ăn đấm này lão già!';
    grab.speak('Ăn đấm này!', 2200);
    director.speakTts(subtitleText, 's4_grab_attack', 'TAI_XE_GRAB');

    director.targetCamPos.set(-1.4, 1.5, -1.5);
    director.targetLookAt.set(-0.15, 1.15, -3.7);
  }
  // 4.2: BULLET TIME & SLOW-MOTION NÉ ĐÒN MA TRẬN CHÍNH XÁC KHI NẮM ĐẤM LAO ĐẾN (34.5s - 37.5s, tức 2.5 <= tInScene < 5.5)
  else if (tInScene < 5.5) {
    grab.root.position.set(-0.65, 0.22, -3.7);
    grab.root.rotation.y = Math.PI * 0.35;
    grab.playAction('punch');
    grab.setExpression('yelling');

    // Bác Trà Đá ngửa người né đòn quay chậm nghệ thuật
    trada.root.position.set(0.4, 0.22, -3.7);
    trada.root.rotation.y = -Math.PI * 0.35;
    trada.playAction('dodge');
    trada.setExpression('neutral');

    if (!director.lastTriggeredSfx['whoosh_1']) {
      director.playWhoosh();
      director.lastTriggeredSfx['whoosh_1'] = true;
    }

    speakerName = 'Tài xế Grab';
    subtitleText = 'Hụt rồi?! Sao né nhanh thế?!';
    grab.speak('Sao né nhanh thế?!', 2200);
    director.speakTts(subtitleText, 's4_grab_miss', 'TAI_XE_GRAB');

    // HIỆU ỨNG BULLET TIME ORBIT QUANH TÂM ĐIỂM NÉ ĐÒN (-0.15, 1.15, -3.7)
    const tOrbit = (tInScene - 2.5) / 3.0;
    const startAngle = 0; // Trực diện
    const endAngle = -Math.PI * 0.45; // Quét 81 độ sang sườn trái
    const angle = startAngle + tOrbit * (endAngle - startAngle);
    const orbitRadius = 3.2;
    const camX = -0.15 + Math.sin(angle) * orbitRadius;
    const camZ = -3.7 + Math.cos(angle) * orbitRadius;

    director.targetCamPos.set(camX, 1.55, camZ);
    director.targetLookAt.set(-0.15, 1.15, -3.7);
  }
  // 4.3: CÚ ĐẤM PHẢN ĐÒN & CAMERA SHAKE CỰC MẠNH & CẬN MẶT GRAB HOA MẮT (37.5s - 41.0s, tức 5.5 <= tInScene < 9.0)
  else if (tInScene < 9.0) {
    grab.hideSpeech();
    grab.root.position.set(-0.65, 0.22, -3.7);
    grab.root.rotation.y = Math.PI * 0.35;
    grab.playAction('stumble');
    grab.setExpression('dizzy');

    trada.root.position.set(0.4, 0.22, -3.7);
    trada.root.rotation.y = -Math.PI * 0.35;
    trada.playAction('punch');
    trada.setExpression('angry');

    if (!director.lastTriggeredSfx['punch_1']) {
      director.playPunchImpact();
      director.screenShakeIntensity = 0.5; // Camera Shake chấn động cực mạnh khi dính đấm!
      director.lastTriggeredSfx['punch_1'] = true;
    }

    speakerName = 'Bác Bán Trà Đá';
    subtitleText = 'BỘP! Mày dám manh động với người già à?!';
    trada.speak('Mày dám manh động với người già à?!', 3200);
    director.speakTts('Mày dám manh động với người già à?!', 's4_trada', 'NGUOI_BAN_TRA_DA');

    // CẬN CẢNH ĐẶC TẢ CẢM XÚC CHÍNH DIỆN MẶT GRAB HOA MẮT CHOÁNG VÁNG
    director.targetCamPos.set(-0.65, 1.45, -2.5);
    director.targetLookAt.set(-0.65, 1.3, -3.7);
  }
  // 4.4: GRAB ÔM MẶT CHOÁNG VÁNG LẢO ĐẢO (41.0s - 44.0s, tức tInScene >= 9.0)
  else {
    trada.hideSpeech();
    grab.root.position.set(-0.65, 0.22, -3.7);
    grab.playAction('stumble');
    grab.setExpression('dizzy');

    speakerName = 'Tài xế Grab';
    subtitleText = 'Ối giời ôi... sao đấm đau thế... hoa hết cả mắt...';
    grab.speak('Ối giời ôi... hoa hết cả mắt...', 2800);
    director.speakTts(subtitleText, 's4_grab_dizzy', 'TAI_XE_GRAB');

    // Camera Action góc chéo theo dõi Grab lảo đảo
    director.targetCamPos.set(-1.6, 1.5, -1.2);
    director.targetLookAt.set(-0.65, 1.2, -3.7);
  }

  return { sceneIndex, subtitleText, speakerName };
}

// ========================================================
// PHÂN CẢNH 5: GRAB ĐO SÀN & SECONDARY SHAKE & CÂU THOẠI 70 TUỔI (44.0s -> 62.0s)
// ========================================================
export function applyScene5(director, time, actors) {
  const { ba, grab, xanh, trada } = actors;
  const sceneIndex = 4;
  const tInScene = time - 44.0;
  let subtitleText = '';
  let speakerName = '';

  trada.hideSpeech();
  ba.hideSpeech();
  grab.hideSpeech();
  xanh.hideSpeech();

  // 5.1: Loạng choạng cực nhanh 1.2s rồi ngã sập sàn đo ván (44.0s - 45.2s, tức tInScene < 1.2)
  if (tInScene < 1.2) {
    const pStumble = tInScene / 1.2;
    grab.root.position.set(-0.65 - pStumble * 0.3, 0.22, -3.7);
    grab.playAction('stumble');
    grab.setExpression('dizzy');

    trada.root.position.set(0.4, 0.22, -3.7);
    trada.root.rotation.y = -Math.PI * 0.25;
    trada.playAction('taunt');
    trada.setExpression('neutral');

    speakerName = 'Tài xế Grab';
    subtitleText = 'Không xong rồi... ngã đây...';
    grab.speak('Không xong rồi... ngã đây...', 1200);
    director.speakTts(subtitleText, 's5_grab_stumble', 'TAI_XE_GRAB');

    director.targetCamPos.set(-1.2, 1.6, -1.0);
    director.targetLookAt.set(-0.8, 0.9, -3.7);
  }
  // 5.2: Grab ngã đo sàn & Bác Trà Đá cận cảnh phủi tay 70 tuổi (45.2s - 54.0s, tức 1.2 <= tInScene < 10.0)
  else if (tInScene < 10.0) {
    grab.root.position.set(-0.95, 0.22, -3.75);
    grab.playAction('fall_forward');
    grab.setExpression('dizzy');

    if (!director.lastTriggeredSfx['body_fall']) {
      director.playBodyFall();
      director.screenShakeIntensity = 0.35; // Secondary Camera Shake rung chấn khi ngã dập đất!
      director.lastTriggeredSfx['body_fall'] = true;
    }

    trada.root.position.set(0.4, 0.22, -3.7);
    trada.root.rotation.y = -Math.PI * 0.25;
    trada.playAction('taunt');
    trada.setExpression('neutral');

    ba.root.position.set(-0.1, 0.22, -4.6);
    ba.playAction('cheer');
    ba.setExpression('happy');

    xanh.root.position.set(1.1, 0.22, -3.8);
    xanh.playAction('wave');
    xanh.setExpression('happy');

    speakerName = 'Bác Bán Trà Đá';
    subtitleText = 'Tôi năm nay 70 tuổi chưa gặp trường hợp này bao giờ!';
    trada.speak('Tôi năm nay 70 tuổi chưa gặp trường hợp này bao giờ!', 4200);
    director.speakTts(subtitleText, 's5_trada', 'NGUOI_BAN_TRA_DA');

    // CẬN CẢNH ĐẶC TẢ CẢM XÚC BÁC TRÀ ĐÁ UY NGHIÊM PHỦI TAY
    director.targetCamPos.set(0.4, 1.55, -2.4);
    director.targetLookAt.set(0.4, 1.3, -3.7);
  }
  // 5.3: Xanh SM tươi cười dắt Bác Ba đi xe điện (54.0s - 62.0s, tức tInScene >= 10.0)
  else {
    grab.root.position.set(-0.95, 0.22, -3.75);
    grab.playAction('fall_forward');

    trada.root.position.set(0.4, 0.22, -3.7);
    trada.playAction('taunt');

    ba.root.position.set(-0.1, 0.22, -4.6);
    ba.playAction('greet');
    ba.setExpression('happy');

    xanh.root.position.set(1.1, 0.22, -3.8);
    xanh.playAction('greet');
    xanh.setExpression('happy');

    speakerName = 'Bác Tài Xanh SM';
    subtitleText = 'Dạ thôi bác Ba, để con chở bác đi xe điện cho an toàn lành lặn!';
    xanh.speak('Dạ thôi bác Ba, để con chở bác đi xe điện!', 4200);
    director.speakTts(subtitleText, 's5_xanh', 'TAI_XE_XANH_SM');

    // Camera Crane High-Angle nhìn toàn cảnh đường phố yên bình
    director.targetCamPos.set(-0.8, 3.8, 1.2);
    director.targetLookAt.set(-0.4, 0.5, -3.8);
  }

  return { sceneIndex, subtitleText, speakerName };
}
